import React, { useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"

const initialValue = {id: null, IsoLanguage: "", Description: ""}

const AddEditLanguageModal = ({editLanguage = null, show, onHide, onSave, onDelete}) => {
    const [language, setLanguage] = useState(initialValue)
    
    useEffect(()=>{

        if(editLanguage) {
            setLanguage({
                id: editLanguage.id,
                IsoLanguage: editLanguage.IsoLanguage,
                Description: editLanguage.Description || ""
            })
        } else {
            setLanguage(initialValue)
        }
    }, [show])

    const handleSave = () => {
        onSave(language)
    }

    const handleDelete = () => {
        onDelete(language)
    }

    const handleChange = (e) => {
        setLanguage({
            ...language,
            [e.target.name]: e.target.value
        })
    }

    const handleRadioButtonChange = e => {
        setLanguage({
            ...language,
            [e.target.name]: e.target.value
        })
    }

    return <Modal show={show} onHide={onHide}>
        <Modal.Header>
            <Modal.Title>
                {editLanguage ? "Edit feature flag #" + editLanguage.id : "Create feature flag"}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form>
            <Form.Group>
                <Form.Label>Iso Language</Form.Label>
                <Form.Control name="IsoLanguage" placeholder="Enter iso language" value={language.IsoLanguage} onChange={handleChange}/>
            </Form.Group>
            <Form.Group>
                <Form.Label>Description</Form.Label>
                <Form.Control name="Description" placeholder="Enter language description" value={language.Description} onChange={handleChange} />
            </Form.Group>
        </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="default" onClick={onHide}>Cancel</Button>
            {editLanguage && <Button onClick={handleDelete} variant="danger">Delete</Button>}
            <Button onClick={handleSave}>Save</Button>
        </Modal.Footer>
    </Modal>
}

export default AddEditLanguageModal